import clsx from 'clsx'
import React, {PropsWithChildren} from 'react'

import {classes} from './styles'

type Props = {
  className?: string
}

const Drawer = React.forwardRef<HTMLDivElement, PropsWithChildren<Props>>(({children, className}, ref) => {
  return (
    <div ref={ref} className={clsx(classes.root, className)}>
      {children}
    </div>
  )
})

export default Drawer
